export const HYDRA_TEST_VARIABLE = 'htv'; // currently not a real test; used for documentation and unit testing
export const HYDRA_PUSH_NOTIFICATIONS = 'mpn';
export const HYDRA_SEARCH_INLINE_VERTICAL_RECOS = 'pita'; // [P]ain [I]n [T]he [A]ss || Search page inline vertical right side recos
export const HYDRA_HF_LOCALE = 'hola'; // Zappos HF locale test
export const HYDRA_OOSM = 'oosm'; // [O]ut [O]f [S]tock [M]obile
export const HYDRA_CHECKOUT_SHIP_SECTION_ADJUSTMENT = 'cssa'; // [C]heckout [S]hip [S]ection [A]djustment
export const HYDRA_CHECKOUT_MOVE_TO_FAVORITES = 'cmtf'; // [C]heckout [M]ove [T]o [F]avorites
export const HYDRA_CHECKOUT_PIXEL_SERVER = 'cops'; // [C]heck[o]ut [P]ixel [S]erver
export const HYDRA_BRAND_NAME_SEARCH = 'bnsr'; // [B]rand [N]ame [S]ea[R]ch
export const HYDRA_SEARCH_COLOR_SWATCHES = 'crss'; // Search [C]olo[r] [S]watche[s]
export const HYDRA_PLACEBO_SEARCH = 'posh'; // [P]laceb[o] [S]earc[h]
export const HYDRA_PLACEBO_PDP = 'popp'; // [P]laceb[o] [P]roduct [P]age
export const HYDRA_PDP_PRODUCT_ANGLES = 'pdng'; // [PD]P Product a[NG]les
export const HYDRA_6PM_MARTY_RETURNS = '6mrt'; // [6]pm [M]arty [R]e[t]urns
export const HYDRA_ORDER_DETAIL_FIT_SURVEY = 'orfs'; // [Or]der Detail [F]it [S]urvey
export const HYDRA_STREAM_RESPONSE = 'strm'; // Response [Str]ea[m]ing
export const HYDRA_SOCIAL_COLLECTIONS = 'soc'; // [So]cial [C]ollections
export const HYDRA_CHECKOUT_SHIPPING_DOWNGRADE = 'csd'; // [C]heckout [S]hipping [D]owngrade
export const HYDRA_FONT_PRELOAD = 'fp'; // [F]ont [P]reload
export const HYDRA_ADS = 'ads';
export const HYDRA_RET = 'ret'; // [Re]wards [T]ransparency
export const HYDRA_CROSS_SITE_SELLING = 'xsll'; // [X]Cross Site [S]e[l][l]ing
export const HYDRA_ZEN_RETURNS = 'fzr'; // [F]ind[Z]en [R]eturns
export const HYDRA_BUY_NOW_BUTTON = 'bn'; // [B]uy [N]ow Button
export const HYDRA_SEO_H1_TITLE_COPY = 'shtc'; // [S]EO [H]1 [T]itle [C]opy
export const HYDRA_SEO_COPY_LOCATION = 'scop'; // [S]EO [Co]py [P]osition
export const HYDRA_BANNER_ADS_SEARCH = 'bads'; // [B]anner [ADS]
export const HYDRA_6PM_ADSENSE = 'sad'; // [S]ixPM [Ad]sense
export const HYDRA_6PM_DISPLAY_ADS = 'dad'; // 6pm [D]isplay [Ad]s
export const HYDRA_6PM_DISPLAY_IFRAME_ADS = 'dadi'; // 6pm [D]isplay [Ad]s [i]Frame
export const HYRDA_NONPERSONALIZED_FACET_SEARCH_BOOST = 'nope';
export const HYDRA_VIP_DASHBOARD = 'vda'; // [V]ip [Da]shboard; rebrand of Rewards -> VIP
export const HYDRA_PERSONALIZED_SIZING_ROUNDER = 'prsr'; // [P]e[R]sonalized [S]izing [R]ounder
export const HYDRA_DOUBLE_PRODUCT_IN_CART = 'dpic'; // [D]ouble [P]roduct [I]n [C]art
export const HYDRA_PERSONALIZED_CATEGORIES = 'cats'; // Personalized [CAT]egorie[S];
export const HYDRA_CHECKOUT_STICKY_PLACE_ORDER = 'cspo'; // Sticky Place Order
export const HYDRA_PDP_STORIES = 'psts'; // [P]roduct Page [S][t]orie[s]
export const HYRDA_SIXPM_AUTOMATED_PAGES = 'spam'; // [S]ix [P]M [A]uto[M]ated Pages
export const HYDRA_PDP_BUY_BOX_CONTENT = 'pbbc'; // [P]roduct Page [B]uy [B]ox [C]ontent
export const HYDRA_PDP_ODSP_LINK_CHANGE = 'polc'; // [P]roduct Page [O]DSP [L]ink [C]hange
export const HYDRA_MOBILE_STYLEROOM_REDIRECT = 'msrp'; // [M]obile [S]tyleRoom [R]edirect [P]dp
export const HYDRA_SAVE_SEARCHES = 'sase'; // [SA]ve [SE]arch
export const HYDRA_SAVE_AND_APPLY_FILTERS = 'savi'; // [Sa]ve and apply f[I]lters
export const HYDRA_CHECKOUT_HOLIDAY_SHIP_OPTIONS = 'chso'; // [C]heckout [H]oliday [S]hip [O]ptions
export const HYDRA_VIP_RENDER_ACTIVITY = 'vra'; // [V]ip [R]ender [A]ctivity
export const HYDRA_LABELLESS_RETURNS = 'llr'; // [L]abel[L]ess [R]eturns
export const HYDRA_LLAMA_DISMISS_BTN_REMOVAL = 'ldbr'; // [L]lama [D]ismiss [B]utton [R]emoval
